/** @jsxImportSource @emotion/react */
import {
  Box,
  BorderStyle,
  Color,
  Display,
  FontWeight,
  Icon,
  IconVariant,
  JustifyContent,
  Text,
  AlignItems,
  Heading2,
} from '@gousto-internal/citrus-react'
import { Link } from 'react-router-dom'
import { useFetchTopArticles } from '../../hooks/useFetchTopArticles'
import { LinksList } from '../LinksList'
import { HelpCentre } from '../../common/tracking'
import { SearchShowMoreButton } from '../SearchShowMoreButton'
import { ContentLoader } from '../ContentLoader'

type SearchFAQProps = {
  query: string
  onShowMore?: () => void
  isMobileOnly?: boolean
  withArticle?: boolean
}

const SearchFAQ = ({
  query,
  onShowMore,
  isMobileOnly = false,
  withArticle = false,
}: SearchFAQProps) => {
  const { isTopArticlesFetching, topArticles } = useFetchTopArticles(4)

  return (
    <Box
      css={isMobileOnly && {
        '@media (min-width: 640px)': {
          display: 'none',
        },
      }}
    >
      <LinksList>
        <Box
          paddingH={[0, 4]}
          bg={Color.White}
          borderStyle={BorderStyle.Solid}
          borderColor={Color.ColdGrey_100}
          borderWidth={0.5}
        >
          {withArticle && (
            <Box
              paddingH={4}
              paddingV={4}
              borderStyle={BorderStyle.Solid}
              borderColor={Color.ColdGrey_100}
              borderBottomWidth={0.5}
            >
              {
                topArticles
                  ? <Heading2 color={Color.ColdGrey_900} size={4}>Most popular articles</Heading2>
                  : <ContentLoader />
              }
            </Box>
          )}
          {topArticles?.map(({ title, url, id }, index) => (
            <Link
              key={id}
              to={url}
              css={{ display: 'block', textDecoration: 'none' }}
              data-tracking-action={HelpCentre.HELP_CENTRE_SEARCH_ARTICLE_CLICK}
              data-tracking-property={JSON.stringify({
                search_term: query,
                article_name: title,
              })}
            >
              <Box
                display={Display.Flex}
                justifyContent={JustifyContent.SpaceBetween}
                paddingV={4}
                paddingH={[4, 0]}
                paddingRight={[2, 0]}
                alignItems={AlignItems.Center}
                minHeight="64px"
              >
                <Text size={2} color={Color.ColdGrey_900} fontWeight={FontWeight.SemiBold}>
                  {title}
                </Text>
                <Icon
                  name="chevron_right"
                  variant={IconVariant.Actionable}
                />
              </Box>
              {index !== topArticles.length - 1 && (
                <Box
                  borderStyle={BorderStyle.Solid}
                  borderColor={Color.ColdGrey_100}
                  borderBottomWidth={0.5}
                />
              )}
            </Link>
          ))}
        </Box>
      </LinksList>
      {(!isTopArticlesFetching && onShowMore) && <SearchShowMoreButton onClick={onShowMore} query={query} text="Show more" />}
    </Box>
  )
}

export { SearchFAQ }
